import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { Funnel } from "redmond";
import { IStoreState } from "../../../../reducers/types";

import { TravelWalletSelection } from "./component";
import {
  getCreditToApply,
  getFetchApplicableTravelWalletItemsCallState,
  getIsTravelWalletCreditPaymentOnly,
  getIsTravelWalletOfferPaymentOnly,
  getOffers,
  getOfferToApply,
  getRewardsPaymentAccountReferenceId,
  getSelectedPaymentMethodId,
  getIsStackedTravelWalletPaymentOnly,
  getBestOfferOverall,
  getMaxApplicableTravelWalletCreditAmount,
  getVacationRentalsIsStackedTravelWalletPaymentOnly,
  getVacationRentalsIsTravelWalletCreditPaymentOnly,
  getVacationRentalsIsTravelWalletOfferPaymentOnly,
  getVacationRentalsMaxApplicableTravelWalletCreditAmount,
  getApplicableCredit,
  getApplicableCreditsBreakdown,
  getApplicableCreditForHomes,
  getApplicableCreditsBreakdownForHomes,
  getIneligibleCreditsBreakdownForHomes,
  getIneligibleCreditsBreakdown,
  getPriceQuotePricing,
  getPricingEstimateTotal,
  getEligibleRestrictedPcCredits,
  getRestrictedCreditAmountToApply,
  getAppliedRestrictedCredits,
  getMaxApplicableRestrictedCreditAmounts,
  getIsRestrictedCreditCoveringTotal,
  getIsBookingTotalCovered,
} from "../../reducer";
import {
  setOfferToApply,
  setSelectedRewardsPaymentTotal,
  resetPaymentCardSelectedAccounts,
  setCreditToApply,
  setRestrictedCreditAmountToApply,
} from "../../actions/actions";
import {
  getTravelCreditsHistoryTransaction,
  getAllTravelWalletOffers,
  getPartialHistoryValidFromTime,
} from "../../../travel-wallet/reducer";
import { getRewardsAccounts } from "../../../rewards/reducer";
import { getVacationRentalShopSelectedListing } from "../../../vacation-rental-shop/reducer";
import { getPremierCollectionShopSelectedAvailability } from "../../../shop/reducer/selectors";

const mapStateToProps = (state: IStoreState) => {
  const selectedHome = getVacationRentalShopSelectedListing(state);
  const quotePricing = getPriceQuotePricing(state);
  const estimatePricing = getPricingEstimateTotal(state);
  const bookingTotal =
    quotePricing?.payNowTotal.fiat.value ?? estimatePricing?.fiat.value ?? 0;

  return {
    offers: getOffers(state),
    offerToApply: getOfferToApply(state),
    fetchApplicableTravelWalletItemsCallState:
      getFetchApplicableTravelWalletItemsCallState(state),
    selectedPaymentMethodId: getSelectedPaymentMethodId(state) ?? "",
    selectedRewardsPaymentAccountId: getRewardsPaymentAccountReferenceId(state),
    credits: selectedHome
      ? getApplicableCreditForHomes(state)
      : getApplicableCredit(state),
    creditBreakdown: selectedHome
      ? getApplicableCreditsBreakdownForHomes(state)
      : getApplicableCreditsBreakdown(state),
    creditsToApply: getCreditToApply(state),
    isStackedTravelWalletPaymentOnly: selectedHome
      ? getVacationRentalsIsStackedTravelWalletPaymentOnly(state)
      : getIsStackedTravelWalletPaymentOnly(state),
    isTravelCreditPaymentOnly: selectedHome
      ? getVacationRentalsIsTravelWalletCreditPaymentOnly(state)
      : getIsTravelWalletCreditPaymentOnly(state),
    isTravelWalletOfferPaymentOnly: selectedHome
      ? getVacationRentalsIsTravelWalletOfferPaymentOnly(state)
      : getIsTravelWalletOfferPaymentOnly(state),
    creditsHistoryTransaction: getTravelCreditsHistoryTransaction(state),
    partialHistoryValidFromTime: getPartialHistoryValidFromTime(state),
    bestOverallOffer: getBestOfferOverall(state),
    rewardsAccounts: getRewardsAccounts(state),
    maxApplicableTravelWalletCredit: selectedHome
      ? getVacationRentalsMaxApplicableTravelWalletCreditAmount(state)
      : getMaxApplicableTravelWalletCreditAmount(state),
    ineligibleCreditsBreakdown: selectedHome
      ? getIneligibleCreditsBreakdownForHomes(state)
      : getIneligibleCreditsBreakdown(state),
    bookingTotal,
    allWalletOffers: getAllTravelWalletOffers(state),
    currentFunnel: selectedHome ? Funnel.Home : Funnel.Lodging,
    selectedLodgingId: selectedHome ? undefined : getPremierCollectionShopSelectedAvailability(state)?.lodging?.id,
    eligibleRestrictedPcCredits: getEligibleRestrictedPcCredits(state),
    restrictedCreditAmountToApply: getRestrictedCreditAmountToApply(state),
    appliedRestrictedCredits: getAppliedRestrictedCredits(state),
    maxApplicableRestrictedCreditAmounts: getMaxApplicableRestrictedCreditAmounts(state),
    restrictedCreditCoversTotal: selectedHome ? false : getIsRestrictedCreditCoveringTotal(state),
    isBookingTotalCovered: selectedHome ? false : getIsBookingTotalCovered(state),
  };
};

export const mapDispatchToProps = {
  setOfferToApply,
  resetPaymentCardSelectedAccounts,
  setSelectedRewardsPaymentTotal,
  setCreditToApply,
  setRestrictedCreditAmountToApply,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type TravelWalletSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedTravelWalletSelection = withRouter(
  connector(TravelWalletSelection)
);
